import { HighlightAvatarCards as HighlightAvatarCards$1, AvatarCard } from '@cbhq/cdx-components';
import { mapEntryLink } from '../../globals/navlink.js';
import { CONTENTFUL_COMPONENTS_STYLE_MAP } from '../contentToPropsMap.js';
import { Linkedin } from './icons/Linkedin.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_AVATAR_CARDS_CONTENT_MODEL_ID = 'cdxHighlightAvatarCards';
function HighlightAvatarCards({
  headline,
  subhead,
  anchor,
  avatarCards,
  gridColumns = 4,
  firstRowColumns = 2,
  style: styleProp,
  hasSpacingTop
}) {
  const style = CONTENTFUL_COMPONENTS_STYLE_MAP[styleProp];
  return /*#__PURE__*/jsx(HighlightAvatarCards$1, {
    headline: headline,
    subhead: subhead,
    anchor: anchor,
    style: style,
    gridColumns: gridColumns,
    hasSpacingTop: hasSpacingTop,
    children: avatarCards && avatarCards.map(({
      fields: {
        link,
        headline,
        subtext,
        avatar,
        hideLinkedinLogo
      }
    }, index) => {
      const _mapEntryLink = mapEntryLink(link),
        url = _mapEntryLink.url,
        label = _mapEntryLink.label;
      const imageSrc = avatar?.fields?.file?.url;
      const imageAlt = avatar?.fields?.description;
      return /*#__PURE__*/jsx(AvatarCard, {
        headline: headline,
        subtext: subtext,
        url: url,
        label: label,
        style: style,
        imageFit: "contain",
        imageAlt: imageAlt || '',
        imageSrc: imageSrc,
        icon: !hideLinkedinLogo && /*#__PURE__*/jsx(Linkedin, {}),
        gridRow: setGridRow(index + 1, firstRowColumns, gridColumns)
      }, label + index);
    })
  });
}
const setGridRow = (gridItemNumber, firstRowCols = 2, cols = 4) => {
  let gridRow = 1;
  let gridItemNumberCloned = gridItemNumber;
  while (gridItemNumberCloned > firstRowCols || gridItemNumberCloned > firstRowCols && gridItemNumberCloned > cols) {
    gridRow++;
    gridItemNumberCloned -= cols;
  }
  return gridRow;
};
export { HIGHLIGHT_AVATAR_CARDS_CONTENT_MODEL_ID, HighlightAvatarCards };
//# sourceMappingURL=HighlightAvatarCards.js.map
